<template>
  <li>
    <span :class="edit ? 'edit' : 'view'">Password</span>
    <span v-if="edit">
      <PasswordComponent
        :user_email="user_email"
        :show_current_password_field="true"
        @end-password-update-process="handeCancelRequest()"
      />
    </span>
    <span v-else>*********************</span>
    <span>
      <a class="vue-anchor" @click="editClick()">
        <span class="icon-edit"></span>
        Edit
      </a>
    </span>
  </li>
</template>

<script>
  import PasswordComponent from '~/components/user/PasswordComponent.vue';

  export default {
    props: {
      user_email: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        edit: false,
      };
    },
    components: {
      PasswordComponent,
    },
    methods: {
      editClick: function () {
        this.edit = true;
      },
      handeCancelRequest: function () {
        this.edit = false;
      },
    },
  };
</script>
